<template>
  <div>
    <v-container class="pt-0 pb-5" v-if="mainStore.module.id">
      <v-row>
        <v-col>
          <div class="pa-2 rounded elevation-1 bg-white">
            <v-btn color="primary-dark" @click="$router.push({ name: 'Administration' })" density="compact"
              variant="outlined">
              <v-icon left>mdi-arrow-left</v-icon>
              Retour
            </v-btn>
            <v-row>
              <v-col md="6" cols="12">
                <div class="text-h6 mt-2">Utilisateurs autorisés sur {{ mainStore.module.base }}</div>
                <ListAuthorizedUsers :key="refresher"></ListAuthorizedUsers>
              </v-col>
              <v-col md="6" cols="12">
                <div class="text-h6 my-2">Ajouter un utilisateur</div>
                <AddAuthorizedUserForm @success="refresher++"></AddAuthorizedUserForm>
              </v-col>
            </v-row>
          </div>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
import { mapStores } from "pinia";
import { useMainStore } from "@/stores/mainStore";
import ListAuthorizedUsers from "@/components/Administration/Gestion_Acces/ListAuthorizedUsers.vue";
import AddAuthorizedUserForm from "@/components/Administration/Gestion_Acces/AddAuthorizedUserForm.vue";
export default {
  components: { ListAuthorizedUsers, AddAuthorizedUserForm },
  data() {
    return {
      refresher: 0,
    };
  },
  computed: {
    ...mapStores(useMainStore),
  },
  created() {

  },
};
</script>

<style lang="scss" scoped></style>